<mat-card style="height: 630px">
  <form #loginForm="ngForm" enctype="multipart/form-data">
    <mat-toolbar style="float:left;clear:both;width:100%;" color="secondary">
      <h2 style="padding-left:2px">{{ 'seguimentTecnicDialog.titol' | translate }}</h2>
      <div style="width:100%;float:right">
        <button mat-icon-button style="float: right; margin-right:0" (click)="close()" matTooltip="{{ 'common.tancar' | translate }}" attr.aria-label="{{ 'common.tancar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
        <button mat-icon-button style="float: right; margin-right:0" (click)="desar()" matTooltip="{{ 'common.desar' | translate }}" attr.aria-label="{{ 'common.desar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
      </div>
    </mat-toolbar>
    <mat-card-content style="float:left;clear:both;padding: 24px 5px;">
      <mat-form-field style="width:20%">
        <mat-select style="width:100%" [(ngModel)]="editSeguimentTecnicData.tipus" [ngModelOptions]="{standalone: true}" placeholder="{{ 'propostaMi.camps.tipus' | translate }}">
          <!-- <mat-option *ngFor="let tipus of possibleTipus" [value]="tipus.nom" [selected]="tipus === editSeguimentTecnicData.tipus">{{tipus.nom}}</mat-option> -->
          <mat-option *ngFor="let tipus of possibleTipus" [value]="tipus.codi" [selected]="tipus.codi === editSeguimentTecnicData.tipus">
             {{ tipus.text }}
           </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width:25%">
        <mat-select style="width:100%" [(ngModel)]="editSeguimentTecnicData.sub_tipus" [ngModelOptions]="{standalone: true}" placeholder="{{ 'ticketingDialog.subTipus' | translate }}">
          <!-- <mat-option *ngFor="let subtipus of possibleSubTipus" [value]="subtipus.nom" [selected]="subtipus === editSeguimentTecnicData.sub_tipus">{{subtipus.nom}}</mat-option> -->
          <mat-option *ngFor="let subtipus of possibleSubTipus" [value]="subtipus.codi" [selected]="subtipus.codi === editSeguimentTecnicData.sub_tipus">
             {{ subtipus.text }}
           </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width:45%">
        <mat-select style="width:100%" [(ngModel)]="llistaParticipants" [ngModelOptions]="{standalone: true}" placeholder="{{ 'seguimentTecnicDialog.participants' | translate }}" multiple="true">
          <mat-option *ngFor="let participants of possibleAssistents" [value]="participants" [selected]="editSeguimentTecnicData.participants && editSeguimentTecnicData.participants.includes(participants)">{{participants}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width:30%">
          <input matInput placeholder="{{ 'seguimentTecnicDialog.lloc' | translate }}" name="lloc" 
        [(ngModel)]="editSeguimentTecnicData.lloc" ngDefaultControl
       />
      </mat-form-field>
      <mat-form-field style="width:130px">
       <input matInput placeholder="{{ 'seguimentTecnicDialog.dataPrevista' | translate }}" name="data" type="date"
         [(ngModel)]="editSeguimentTecnicData.data" ngDefaultControl (change)="chgDataAvis()"
       />
      </mat-form-field> 
      <mat-form-field style="width:130px">
       <input matInput placeholder="{{ 'seguimentTecnicDialog.hora' | translate }}" name="hora" type="time"
        [(ngModel)]="editSeguimentTecnicData.hora" ngDefaultControl
       />
      </mat-form-field> 
      <mat-form-field style="width:130px">
       <input matInput placeholder="{{ 'ticketingDialog.dataRealitzacio' | translate }}" name="data_realitzacio" type="date"
        [(ngModel)]="editSeguimentTecnicData.data_realitzacio" ngDefaultControl
       />
      </mat-form-field> 
      <mat-form-field style="width: 95%">
        <textarea matInput placeholder="{{ 'seguimentTecnic.colAssumpte' | translate }}" name="assumpte" rows="2" [(ngModel)]="editSeguimentTecnicData.assumpte" style="width: 100%">
        </textarea>
      </mat-form-field> 
      <mat-form-field style="width: 95%">
        <textarea matInput placeholder="{{ 'ticketingDialog.acords' | translate }}" name="acords" rows="2" [(ngModel)]="editSeguimentTecnicData.acords" style="width: 100%">
        </textarea>
      </mat-form-field> 
      <mat-form-field style="width: 95%">
        <textarea matInput placeholder="{{ 'seguimentTecnicDialog.lliuraments' | translate }}" name="lliuraments" rows="2" [(ngModel)]="editSeguimentTecnicData.lliuraments" style="width: 100%">
        </textarea>
      </mat-form-field>
      <mat-card-content>
        <div style="float:left;clear:left; width:100%;margin-bottom:20px;height:30px">
          <div class="lbl_dlg" style="padding-top:7px;float:left;clear:left;width:200px">{{ 'ticketingDialog.documentacioAssociada' | translate }}</div>
          <div class="lbl_dlg" style="float:left;clear:none;margin-left:10px;margin-top:5px" *ngIf="editSeguimentTecnicData.filename"><a href="#" (click)="desarFitxer($event, editSeguimentTecnicData.filename  ,'documents/seguiment-tecnic')" attr.alt="{{ 'ticketingDialog.veureArxiu' | translate }}">{{editSeguimentTecnicData.filename}}</a>
          </div>
          <div class="lbl_dlg" style="margin-left:10px;padding-top:7px" *ngIf="editSeguimentTecnicData.filename">
            <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;margin-top: -20px;cursor:pointer" (click)="editSeguimentTecnicData.filename = ''" color="primary">delete_forever</mat-icon>
          </div>
        </div>
        <div style="float:left;clear:left;width:100%">
          <div style="float:left;clear:left;position: absolute;width:100%;z-index:1;background-color: white">
            <div style="float:left;clear:none;padding-top:5px">{{ 'ticketingDialog.carregarDocument' | translate }}</div>
            <div style="float:left;clear:none">
              <label for="file">
                <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;cursor:pointer" color="primary" matTooltip="{{ 'ticketingDialog.extensioMinuscules' | translate }}" attr.aria-label="{{ 'ticketingDialog.extensioMinuscules' | translate }}" matTooltipClass="tooltip-style">cloud_upload</mat-icon></label>
            </div>
          </div>
          <div style="float:left;clear:left;position: absolute;width:100%">
            <input mat-raised-button color="primary" type="file" filter="jpg;png;doc;docx;pdf;xls;xlsx;gif;zip;rar;odt;ods;ppt;pptx" style="width:80%" placeholder="" id="file" name="file" (change)="onFileChange($event)"/> {{ 'ticketingDialog.maxMida' | translate }}
          </div>
        </div>
        <div style="float:left;clear:left;width:100%" *ngIf="editSeguimentTecnicData.id === 'NEW'">
           {{ 'ticketingDialog.desarPrimer' | translate }}
        </div>
      </mat-card-content>
      <div style="float:left;clear:left;width:100%;padding-top:60px">
        <mat-form-field *ngIf="editSeguimentTecnicData.avis_actiu" style="float:left;clear:left;width:130px">
         <input matInput style="width:130px"
        placeholder="{{ 'seguimentTecnicDialog.dataAvis' | translate }}" name="data_avis" type="date"
        [(ngModel)]="editSeguimentTecnicData.data_avis" ngDefaultControl
       />
        </mat-form-field> 
        <mat-checkbox style="float:left;clear:none;width:150px;padding-top: 10px"
        name="avis_actiu" (click)="chkDataAvis()"
        [(ngModel)]="editSeguimentTecnicData.avis_actiu"
       >{{ 'seguimentTecnicDialog.avisarCoordinador' | translate }}</mat-checkbox>
      </div>
    </mat-card-content>
  </form>
</mat-card>
